import { RouterProvider } from 'react-router-dom';
import { Router } from './Router';
import { useTheme } from 'lib/hooks/useTheme';
import { useFontSize } from 'lib/hooks/useFontSize';
import { useAppSelector } from 'store/hooks';
import { selectUserTheme } from 'store/features/user/selectors';

function App() {
  const userTheme = useAppSelector(selectUserTheme);
  useTheme(userTheme);
  useFontSize();

  return <RouterProvider router={Router} />;
}

export default App;
